var PannellumSceneType;
(function (PannellumSceneType) {
    PannellumSceneType["multires"] = "multires";
    PannellumSceneType["equirectangular"] = "equirectangular";
})(PannellumSceneType || (PannellumSceneType = {}));
var PitchWarningType;
(function (PitchWarningType) {
    PitchWarningType[PitchWarningType["Low"] = 0] = "Low";
    PitchWarningType[PitchWarningType["High"] = 1] = "High";
})(PitchWarningType || (PitchWarningType = {}));

export { PannellumSceneType, PitchWarningType };
